<div class="curtain">

<section class="component-modalDialog redesigned">
    <header>
        <span class="max-width">{{ notification.notification.perex }}</span>
        <span class="date" *ngIf="notification.notification.created">({{ notification.notification.created | displayDate }})</span>
        <a class="closeModalDialog fa fa-close" (click)="closeModal()"></a>
    </header>
    <div class="contentContainer scrollable nativeScrollbar inside">
        <div class="message col-full no-height" [innerHTML]="notification?.notification?.detail | safeHtml"></div>
    </div>
    <footer>
        <a class="button-primary" (click)="closeModal()">Zavřít</a>
    </footer>
</section>

</div><!-- curtain -->